// src/firebase.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyBvL7fggAHGv5mOP97r9adhvxN2sZv789U",
  authDomain: "hapsmiths-a2d6e.firebaseapp.com",
  projectId: "hapsmiths-a2d6e",
  storageBucket: "hapsmiths-a2d6e.firebasestorage.app",
  messagingSenderId: "57298626361",
  appId: "1:57298626361:web:e897a5ba47abe646582ae8"
};

const app = initializeApp(firebaseConfig);

export const messaging = getMessaging(app);

export const registerSW = async () => {
  if ("serviceWorker" in navigator) {
    try {
      const registration = await navigator.serviceWorker.register(
        "/firebase-messaging-sw.js",
        { scope: "/" }
      );
      await registration.update();
      console.log("✅ SW registered:", registration);
      return registration;
    } catch (err) {
      console.error("❌ SW registration failed:", err);
    }
  }
}